import { useEffect } from "react";

const Footer = () => {
  useEffect(() => {
    // "Пробуждает" hover-эффекты после загрузки
    const forceHoverFix = () => {
      document.body.style.pointerEvents = 'none';
      setTimeout(() => {
        document.body.style.pointerEvents = 'auto';
      }, 100);
    };
    
    window.addEventListener('load', forceHoverFix);
    return () => window.removeEventListener('load', forceHoverFix);
  }, []);

  return (
    <div className="footer">
      <span className="nickname"><strong>@IlyaShirko</strong></span>
      <div className="socialLinks">
        <a style={{border: '0'}} href="https://t.me/IlyaShirko" target="_blank" rel="noopener noreferrer">
          <img className="social" src={`${process.env.PUBLIC_URL}/icons/telegram.png`} alt="Telegram" />
        </a>
        
        <a style={{border: '0'}} href="https://vk.com/ilyashirko" target="_blank" rel="noopener noreferrer">
          <img className="social" src={`${process.env.PUBLIC_URL}/icons/vkontakte.png`} alt="VKontakte" />
        </a>
        
        <a style={{border: '0'}} href="mailto:ilyashirko@gmail.com">
          <img className="social" src={`${process.env.PUBLIC_URL}/icons/email.png`} alt="Email" />
        </a>
      </div>
      <span className="outro"><strong>{new Date().getFullYear()}</strong></span>
    </div>
  );
};

export default Footer;